import React, { useEffect, useRef, useState, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";

import RutasCRUD from "../Rutas/RutasCRUD/RutasCRUD";
import { getRutas, eliminarRuta } from "../../../../API/IT/Rutas/RutasRouter";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { toastShow } from "../../../Services/ToastService";

const RutasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rutas, setRutas] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const d = await getRutas();
    setRutas(d);
    setLoading(false);
  };

  const eliminarRouter = async (datos) => {
    const resultado = await eliminarRuta(datos)

    if (resultado[0]?.ESTADO === 1) {
      toastShow(
        toast,
        "success",
        "Datos Eliminados",
        resultado[0]?.MENSAJE
      );
      getInfo();
    } else {
      toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
    }
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdRouter",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "IP",
      headerEn: "IP",
      field: "IP",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "SSID",
      headerEn: "SSID",
      field: "SSID",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Clave SSID",
      headerEn: "SSID Key",
      field: "ClaveSSID",
    },
    {
      header: "Clave Router",
      headerEn: "Key Router",
      field: "ClaveRouter",
    },
    {
      header: "Marca",
      headerEn: "Brand",
      field: "Marca",
    },
    {
      header: "Modelo",
      headerEn: "Model",
      field: "Modelo",
    },
    {
      header: "Serie",
      headerEn: "Series",
      field: "Serie",
    },
    {
      header: "Ubicación",
      headerEn: "Location",
      field: "Ubicacion",
    },
    {
      header: "Area",
      headerEn: "Area",
      field: "Area",
    },
    {
      header: "Estado",
      field: "StatusName",
      Format: "Estado", 
      className:"small",
      filter:false,  
      frozen:true,
      alignFrozen:'right',  
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
    },
    {
      field: "IdRouter",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
        {
          icon: "pi pi-trash",
          tooltip: "Eliminar",
          onClick: (rowData) => {
            eliminarRouter(rowData)
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: rutas,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "rutas", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "rutas", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <RutasCRUD
          listRutas={rutas}
          toastRef={toast}
          rutaDialog={showDialog}
          ruta={selected}
          setRutaDialog={setShowDialog}
          getPos={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default RutasScreen;
